export default __webpack_public_path__ + "static/mb-logo-small-253a1a98e4e43dfd7f8fa68ee840f1d5.png";